if ( ! customElements.get('volume-purchase') ) {

	customElements.define(
		'volume-purchase',
		class VolumePurchase extends HTMLElement {

			connectedCallback() {

				this.productPage = this.closest('[data-js-product-component]');
				this.form = this.productPage ? this.productPage.querySelector('product-form form') : null;

				// No form to drive: leave the pills inert rather than half-wiring them.
				if ( ! this.form ) return;

				this.quantityInput = this.#resolveQuantityInput();
				this.priceTargets = this.#resolvePriceTargets();

				this._onChange = this.#onChange.bind(this);
				this.addEventListener('change', this._onChange);

				this.#apply(this.querySelector('input[type="radio"]:checked'));

			}

			disconnectedCallback() {
				if ( this._onChange ) this.removeEventListener('change', this._onChange);
			}

			#onChange(e) {
				const input = e.target.closest('input[type="radio"]');
				if ( input ) this.#apply(input);
			}

			#apply(input) {

				if ( ! input ) return;

				this.quantityInput.value = input.dataset.quantity;

				const price = input.parentElement.querySelector('template[data-js-volume-price]');
				if ( ! price ) return;

				this.priceTargets.forEach(target => {
					target.innerHTML = price.innerHTML;
				});

			}

			// The theme only outputs a quantity field when the buy buttons block has its
			// quantity selector enabled — it is off on this shop, so the form needs one.
			// Without it cart/add.js falls back to a single unit whatever tier is picked.
			#resolveQuantityInput() {

				const existing = this.form.querySelector('input[name="quantity"]');
				if ( existing ) return existing;

				const hidden = document.createElement('input');
				hidden.type = 'hidden';
				hidden.name = 'quantity';
				this.form.appendChild(hidden);

				return hidden;

			}

			// Two prices to keep in step. The sticky bar lives outside the product component,
			// and the theme only mirrors it onto the main price for products that have
			// variants (component-product-form.js, the data-single-with-options branch) —
			// which these products no longer do.
			#resolvePriceTargets() {

				const targets = [];

				const main = this.productPage.querySelector('[data-update-block="price-button-main"]');
				if ( main ) targets.push(main);

				const sticky = document.querySelector(`sticky-add-to-cart[data-id="${this.productPage.id}"] [data-js-atc-price]`);
				if ( sticky ) targets.push(sticky);

				return targets;

			}

		}
	);

}
